import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import useToast from "./useToast";
import { get_config_depend_param_alert } from "../features/delegation_roles/functions";

// GLOBAL alert toast
const useFeatureToast = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [toast, setToast] = useToast();

    const KEY_PARAMS = searchParams.get("alert");

    useEffect(() => {
        if (KEY_PARAMS) {
            try {
                const { level, content, visible } =
                    get_config_depend_param_alert(KEY_PARAMS);

                if (!visible) {
                    return onStatusChangeToast();
                }

                setToast((state) => {
                    return {
                        ...state,
                        visible,
                        level,
                        content,
                    };
                });
            } catch (error) {
                return console.error("ERROR DEV : ", error);
            }
        }
    }, [KEY_PARAMS]);

    // functions
    const onStatusChangeToast = () => {
        setToast((state) => ({
            ...state,
            visible: false,
        }));
        setSearchParams({});
        return;
    };

    return {
        toast,
        onStatusChangeToast,
    };
};

export default useFeatureToast;
